import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import { ScheduleReferenceDataContext } from "@/pages/human-resources/time-management/schedules/reference-provider/ScheduleReferenceDataProvider.tsx";
import type { ScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/ScheduleReferenceData.ts";

export default function useScheduleReferenceData(): ScheduleReferenceData {
  return useDefinedContextValue(ScheduleReferenceDataContext);
}
